// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","col":"TitleRow__col--gy","title1":"TitleRow__title1--bo","title2":"TitleRow__title2--dD"};